import React from 'react'
import MaterialSymbol from '../material-symbol'

const Monitoring = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="monitoring" {...props} />
))

Monitoring.displayName = 'Monitoring'

export default Monitoring
